import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { bind } from '@ember/runloop';
import { tracked } from '@glimmer/tracking';

import $ from 'jquery';

import type { BoardBaseArgs } from 'webapp/components/board/base';
import BoardMobileComponent from 'webapp/components/board/mobile';

interface BoardMobileFullscreenArgs extends BoardBaseArgs {
	currentZoom?: number;
}

export default class BoardMobileFullscreenComponent extends BoardMobileComponent<BoardMobileFullscreenArgs> {
	isFullscreen = true;

	@tracked windowWidth = 100;

	constructor(owner: Owner, args: BoardMobileFullscreenArgs) {
		super(owner, args);
		this.updateWindowWidth();
	}

	get innerWidth(): number {
		return this.windowWidth;
	}

	get outerWidth(): number {
		return this.innerWidth;
	}

	override get currentZoom(): number {
		if (this.args.currentZoom) {
			return this.args.currentZoom;
		} else {
			return 100 * (300 / this.windowWidth);
		}
	}

	override get fontSize(): number {
		const fontSize = Math.max(10, this.currentZoom / 7);
		this.updateSliderFontSize(fontSize);
		return fontSize;
	}

	updateWindowWidth(): void {
		this.windowWidth = $(window).width()!;
	}

	updateSliderFontSize(fontSize: number): void {
		$('#slider-nav').css({ fontSize: `${fontSize}px` });
	}

	onWindowResize(): void {
		this.updateWindowWidth();
		this.el.find('.scroll .preview-block').trigger('resize.block');
	}

	onScrollSliderNav(e: MouseEvent): void {
		const scrollTop = $(e.target as HTMLElement).scrollTop()!;
		$('#slider-nav').css({ top: -1 * scrollTop });
	}

	bindEvents(): void {
		$(window).on('resize.windowwidth', bind(this, this.onWindowResize));
		this.el.find('.scroll').on('scroll.slidernav', (e: Event) => {
			this.onScrollSliderNav(e as MouseEvent);
		});
	}

	unBindEvents(): void {
		$(window).off('resize.windowwidth scroll.slidernav');
	}

	@action
	override setupView(node: HTMLElement): void {
		super.setupView(node);
		this.bindEvents();
	}

	@action
	override teardownView(): void {
		super.teardownView();
		this.unBindEvents();
	}
}
